import { docValuesDefault } from "../data/types/docValuesDefault";
import { stdObject } from "../data/types/stdObject";
import { arrayToObject } from "../utils/arrayToObject";
import { checkIfObject } from "../utils/checkIfObject";
import { getPrefix } from "../utils/getPrefix";
import { toPrice } from "../utils/toPrice";
import { sendData } from "./sendData";
import { v4 as uuidv4 } from "uuid";

export const callDocInfo = async ({
  user,
  type,
  serie,
  code,
  person = "",
  staff = null,
  items = null,
  issues = {},
  initial = {},
  mainColor,
  logoutAction,
}: {
  user: stdObject;
  type: string;
  serie: number;
  code: number;
  person?: string;
  staff?: stdObject[] | null | undefined;
  items?: stdObject[] | null | undefined;
  issues?: stdObject;
  initial?: stdObject;
  mainColor: string;
  logoutAction: () => void;
}) => {
  const payloadCallDocInfo = {
    type,
    serie,
    code,
    person,
    interv: initial.INT,
  };
  console.log("issues", issues);
  console.log("payloadCallDocInfo", payloadCallDocInfo);

  const responseCallDocInfo: stdObject = await sendData({
    endPoint: "callDocument",
    payload: payloadCallDocInfo,
    logoutAction,
  });
  console.log("responseCallDocInfo", responseCallDocInfo);
  if (responseCallDocInfo.success) {
    if (code === 0 && "issues" in responseCallDocInfo) {
      responseCallDocInfo.issues = responseCallDocInfo.issues.map(
        (e: stdObject) => {
          if (e.NUMSDD in issues) {
            switch (e.TIPSDD) {
              case 0:
                e.CHKSDD = issues[e.NUMSDD];
                break;
              case 1:
              case 6:
                e.DIGSDD = issues[e.NUMSDD];
                break;
              case 3:
              case 8:
                e.TXTSDD = issues[e.NUMSDD];
                break;
              case 5:
                e.DRAWING = issues[e.NUMSDD];
                break;
              default:
                e.CHRSDD = issues[e.NUMSDD];
            }
          }
          return e;
        },
      );
    }

    const itemType = responseCallDocInfo.itemCodes[0].COLUMN_NAME.slice(-3);
    const finalStaff = code ? responseCallDocInfo.staff : staff;
    const finalItems = code ? responseCallDocInfo.items : items;

    return {
      id: uuidv4(),
      type,
      itemType,
      serie,
      code,
      isTransferIn:
        type === "TRA" &&
        code &&
        responseCallDocInfo.data[`ALM2${type}`] === user.ALMSUC,
      prev: code
        ? responseCallDocInfo.prev
        : { [`AGE${type}`]: "", [`EST3${type}`]: 0 },
      data: code
        ? responseCallDocInfo.data
        : responseCallDocInfo.docCodes.reduce(
            (acc: stdObject, key: stdObject) => {
              const prefix = getPrefix(key.COLUMN_NAME);
              acc[key.COLUMN_NAME] =
                prefix in initial ? initial[prefix] : docValuesDefault(prefix);
              return acc;
            },
            {},
          ),
      forms: responseCallDocInfo.forms,
      person: responseCallDocInfo.person ?? {},
      staff:
        (code || staff) && Array.isArray(finalStaff)
          ? arrayToObject({
              key: "CODIA2",
              erase: ["CODIA2"],
              data: finalStaff,
            })
          : responseCallDocInfo.docCodes.find(
                (e: stdObject) => e.COLUMN_NAME === `AGE${type}`,
              )?.COLUMN_NAME && "AGE" in initial
            ? {
                0: {
                  AGEIA2: initial.AGE,
                  NOMIA2: initial.ANO,
                },
              }
            : {},
      issues: type === "SEV" ? responseCallDocInfo.issues : [],
      itemCodes: responseCallDocInfo.itemCodes.map(
        (e: stdObject) => e.COLUMN_NAME,
      ),
      items:
        (code || items) && Array.isArray(finalItems)
          ? finalItems.map((e: stdObject) => {
              if (`PRE${itemType}` in e) {
                e[`PRE${itemType}`] = toPrice(e[`PRE${itemType}`]);
              }
              return { ...e };
            })
          : [],
      batches: {},
      commissions: code ? responseCallDocInfo.commissions : [],
      status: code ? responseCallDocInfo.data[`EST3${type}`] : 1,
      files:
        code && checkIfObject(responseCallDocInfo.files)
          ? Object.values(responseCallDocInfo.files)
          : [],
      mainColor,
      updated: false,
    };
  } else {
    return {};
  }
};
